import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import BulbOffIcon from '../../../assets/Icons/BulbOFF-01.png'
import BilbOnIcon from '../../../assets/Icons/BulbON-01.png'


export const lightsMenu = [
  { name: "table light", type: "white bulb" },
  { name: "sofa abmient", type: "RGB bulb" },
  { name: "behind smart TV", type: "RGB bulb" },
  { name: "above door TV", type: "RGB bulb" },
  { name: "patio door ", type: "Blue bulb" },
  { name: "patio door ", type: "Blue bulb" },
  { name: "patio door ", type: "Blue bulb" },
  { name: "patio door ", type: "Blue bulb" },
  { name: "patio door ", type: "Blue bulb" },
]
export const Icons = {
  BulbOffIcon,
  BilbOnIcon

}

export const LightsSwitch = styled(IconButton)(({ theme }) => ({
  backgroundColor: "#3E3E3E",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: "#FFFFFF",
  width: 167,
  height: 58,
  borderRadius: "10px",
  fontSize: 16,
  justifyContent: "space-evenly"

}));


export const LightsType = styled(IconButton)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: "#FFFFFF",
  width: 170,
  height: 70,
  borderRadius: "10px",
  marginRight: "20px",
  display: "inline-block"

}));

export const ScrollGridStyle = (theme: any) => {
  return {
    [theme.breakpoints.up('lg')]: {
      width: 'auto'
    },
    [theme.breakpoints.only('il')]: {
      width: 1045
    },
    [theme.breakpoints.up('md')]: {
      width: 870
    },
    [theme.breakpoints.only('ip')]: {
      width: 689
    },
    [theme.breakpoints.only('pp')]: {
      width: 320
    },
  }
}
export const colorPickerGridStyle = (theme: any) => {
  return {
    [theme.breakpoints.only('ip')]: {
      display: "flex",
      justifyContent: "center"
    },
    [theme.breakpoints.down('sm')]: {

    }
  }
}
export const SlidersStyle = (theme: any) => {
  return {
    width: 254,
    [theme.breakpoints.only('pp')]: {
      width: 210
    },
    [theme.breakpoints.down('md')]: {
      width: 210
    }
  }
}
export const LightsGrid = (theme: any) => {
  return {

    [theme.breakpoints.only('pp')]: {
      display: "none"
    },
    [theme.breakpoints.down('sm')]: {
      display: "none"
    }
  }
}
